import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useField } from "vee-validate";
import { useAttrs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitCheckBox',
  props: {
    name: {},
    label: {},
    horizontal: { type: [String, Boolean] },
    required: { type: Boolean },
    wrapperClass: {}
  },
  setup(__props: any) {

const props = __props;

const attrs = useAttrs();

const { value, errorMessage } = useField(props.name);

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            _ctx.wrapperClass || '',
            _ctx.horizontal && 'horizontal-wrapper',
        ])
  }, [
    _createVNode(_component_el_form_item, {
      error: _unref(errorMessage),
      class: _normalizeClass(_ctx.horizontal ? 'form-item-horizontal' : ''),
      validateStatus: _unref(errorMessage) ? 'error' : 'success',
      size: "default"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_checkbox, _mergeProps({
          placeholder: _ctx.label,
          name: _ctx.name,
          label: _ctx.label
        }, _unref(attrs), {
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          "validate-event": false
        }), null, 16, ["placeholder", "name", "label", "modelValue"])
      ]),
      _: 1
    }, 8, ["error", "class", "validateStatus"])
  ], 2))
}
}

})